import * as React from 'react';

import type { ColorPalette } from '@acceligentllc/shared/enums/color';

import ColorPickerInput from 'af-components/Controls/ColorPicker';
import type { Position, Alignment } from 'af-components/Controls/ColorPicker/ColorsGrid';
import type { CellError } from 'af-components/RHFTableCellComponents/error.types';

interface Props {
	value: Nullable<ColorPalette>;
	error?: CellError;
	disabled?: boolean;
	position: Position;
	align: Alignment;
	showAdditionalOptions?: boolean;
	onChange?: (color: ColorPalette) => void;
	onFocus?: () => void;
	fixed?: boolean;
}

const ColorPickerCell: React.FC<Props> = React.memo((props) => {
	const {
		value,
		disabled = false,
		position,
		align,
		showAdditionalOptions = false,
		onChange,
		onFocus,
		fixed,
	} = props;

	return (
		<ColorPickerInput
			align={align}
			disabled={disabled}
			fixed={fixed}
			onChange={onChange}
			onFocus={onFocus}
			position={position}
			showAdditionalOptions={showAdditionalOptions}
			value={value ?? undefined}
			withBorder={false}
		/>
	);
});

export default React.memo(ColorPickerCell);
